<template>
    <div :style="wrapperStyle" :class="{'w-full': !!ratio}">
        <div class="flex items-center justify-center" :class="{'absolute top-0 left-0 right-0 bottom-0 overflow-hidden': !!ratio}">
            <slot/>
        </div>
    </div>
</template>

<script>
import {formatDimension} from "@spoferan/spoferan-ts-core";

    export default {
        name: "AspectRatioBox",

        props: {
            ratio: {
                type: [String, Number],
                default: null,
            }
        },

        computed: {
            wrapperStyle() {
                const style = {};

                if (this.ratio) {
                    style.paddingTop = formatDimension(100 / this.ratio, '%')
                }

                return style;
            }
        }
    }
</script>